import emailSpellChecker from "@zootools/email-spell-checker";
import EMAIL_DOMAINS from "./EmailField/emailDomains";
import type { Validation, UseFormOptions } from "./types";

export function getCustomValidation(
  validation: Validation & { customName: string },
  getValues?: UseFormOptions["getValues"]
): Record<string, any> {
  switch (validation.customName) {
    case "personalDataConditionalRequired":
      return personalDataConditionalRequired(validation, getValues);
    case "emailDomainChecker":
      return emailDomainChecker(validation);
    default:
      return {};
  }
}

function personalDataConditionalRequired(
  validation: Validation,
  getValues?: UseFormOptions["getValues"]
): Record<string, (val: any) => string | null> {
  return {
    validatePersonalDataConditionalRequired: (val: any) => {
      if (
        getValues && (
          getValues("electronicCommunication") === "yes" ||
          getValues("fullDataAgreement") === "yes"
        )
      ) {
        return !!val ? null : validation.message;
      }
      return null;
    },
  };
}

function emailDomainChecker(validation: Validation): Record<string, (val: string) => string | null> {
  return {
    validateEmailDomainChecker: (val: string) => {
      const checkedEmail = emailSpellChecker.run({
        domains: EMAIL_DOMAINS,
        secondLevelDomains: [],
        topLevelDomains: [],
        email: val,
      });

      return !!checkedEmail ? validation.message : null;
    },
  };
}
